

const LOADER_ID = "map-loader-instance"
const currentlyLoading: Set<string> = new Set<string>();


/*setInterval(() => {
    console.log("--------------------------------");
    console.log("Currently loading: ", currentlyLoading);
    console.log("--------------------------------");
}, 1000);*/

const startLoading = (key: string) => {
    currentlyLoading.add(key);
    showLoader();
}

const finishLoading = (key: string) => {

    currentlyLoading.delete(key);
    if (currentlyLoading.size === 0) {
        hideLoader();
    }

}


const showLoader = () => {
    const loader = document.getElementById(LOADER_ID);
    if (loader) {
        loader.classList.remove("hidden");
    }
}

const hideLoader = () => {
    const loader = document.getElementById(LOADER_ID);

    if (loader) {
        loader.classList.add("hidden");
    }
}


export const LoadingManager = {
    startLoading,
    finishLoading
}